import { useEffect } from 'react';
import { useBlocker } from 'react-router';

const usePrompt = (message: string, when: boolean) => {
  const blocker = useBlocker(({ currentLocation, nextLocation }) => when && currentLocation.pathname !== nextLocation.pathname);

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      if (when) {
        event.preventDefault();
        return message;
      }
      return undefined;
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [blocker, when]);

  useEffect(() => {
    if (!when) return;

    try {
      if (blocker.state === 'blocked') {
        if (window.confirm(message)) {
          // Check if blocker is still in a valid state before proceeding
          if (blocker.state === 'blocked') {
            blocker.proceed();
          }
        } else {
          // Check if blocker is still in a valid state before resetting
          if (blocker.state === 'blocked') {
            blocker.reset();
          }
        }
      }
    } catch (error) {
      console.error('Error handling navigation blocker:', error);
      // Fallback: try to reset the blocker if it's in an invalid state
      try {
        if (blocker && typeof blocker.reset === 'function') {
          blocker.reset();
        }
      } catch (resetError) {
        console.error('Error resetting navigation blocker:', resetError);
      }
    }
  }, [blocker, when, message]);
};

export { usePrompt };
